import React, { useState } from "react";
import Sidebar from "../../common/components/Sidebar/sidebar";

import UserManagementView from "../../common/components/userManagementComponents/UserManagementView";

import { useNavigate } from "react-router-dom";
const UserManagement = () => {
  const navigate = useNavigate();

  // const handleChange = (e) => {
  //   setSearchName(e.target.value);
  // };
  // const filteredProducts = tableData?.filter((product) => {
  //   return product?.userId?.toLowerCase().startsWith(searchName?.toLowerCase())||product?.name?.toLowerCase().startsWith(searchName?.toLowerCase())
  // });
  return (
    <>
      <section className="agent_management_main_section">
        <div className="container-fluid">
          <div className="row p-0">
            <div className="col-lg-2 p-0 m-0">
              <Sidebar />
            </div>
            <div className="col-lg-10 p-0 m-0">
              <UserManagementView />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default UserManagement;
